import type { IUserInfo } from "@/account/account-models";
import type { IDictionary } from "@/models";
import { defined } from "@/utils/variable-evaluation";
import { myWebsocketEvent } from "@/websocket/websocket-event";
import type { ITypingPublishConfig } from "./pubnub-models";

export function publishTypingState(
  user: IUserInfo,
  config: ITypingPublishConfig,
  isTyping: boolean
) {
  const { sender_id, chat_id } = config;

  myWebsocketEvent.trigger({
    action: isTyping ? "typing_start" : "typing_stop",
    sender_id,
    chat_id,
  });
}

export function getUserLastOnline(
  user: IUserInfo,
  usersLastOnline: IDictionary<string>
): string {
  if (
    defined(usersLastOnline[user._id]) &&
    new Date(usersLastOnline[user._id]).valueOf() >
      new Date(user.last_online).valueOf()
  ) {
    return usersLastOnline[user._id];
  }
  return user.last_online;
}
